import { useLingui } from "@lingui/react/macro";
import { PatientsFilterInput } from "./PatientsContextComponents";

export const PatientsPatientNameFilterInput = () => {
  const { t } = useLingui();
  return <PatientsFilterInput label={t`Sök patient`} />;
};
